<template>
  <MetricCard
    apiEndpoint="/facebook/reach"
    metricName="REACH"
    :formatData="formatData"
    srcName="Facebook Ads"
  />
</template>

<script setup>
import MetricCard from '@/components/MetricCard.vue';
import { formatNumber } from '@/utils/helperFunctions';
const formatData = (data) => formatNumber(data.data);
</script>
